import React from 'react';
import Styled from 'styled-components';
import {SubNavigation} from '@/web-components';
import {useIntl} from 'react-intl';
import {useHistory, useLocation} from 'react-router-dom';

const NavigatorWrapper = Styled.div`
	margin: 25px 0 -10px;
`;

type ClientSubPage = {
	value: string;
	label: string;
};

type SettingsClientsSubNavProps = {
	clientId: string;
};

export const getClientsSubPages = (clientId: string): ClientSubPage[] =>
	[
		{
			value: `/admin/clients/view-client/${clientId}`,
			label: 'common.client_information',
		},
		{
			value: `/admin/clients/view-client/${clientId}/guest-users`,
			label: 'common.guest_users',
		},
	].filter(Boolean) as ClientSubPage[];

export const findClientsSubPage = (pathname: string, clientId: string): ClientSubPage | undefined => {
	return getClientsSubPages(clientId).find(subPage => pathname === subPage?.value);
};

const SettingsClientsSubNav = ({clientId}: SettingsClientsSubNavProps): JSX.Element => {
	const {formatMessage} = useIntl();
	const {pathname} = useLocation();
	const history = useHistory();
	const activeClientsSubPage = findClientsSubPage(pathname, clientId);

	const handleSetActivePage = (value: string) => {
		const newPage = getClientsSubPages(clientId).some(option => option?.value === value);
		if (activeClientsSubPage?.value !== value && newPage) {
			history.push(value);
		}
	};

	return (
		<NavigatorWrapper>
			{getClientsSubPages(clientId).map(option => (
				<SubNavigation.NavigationItem
					active={activeClientsSubPage?.value === option?.value}
					onClick={() => handleSetActivePage(option?.value)}
					key={option?.value}
					cy={'settings-clients-tabs' + option?.value.toLowerCase().replace('/', '-')}
					userpilot={'settings-clients-tabs' + option?.value.toLowerCase().replace('/', '-')}
				>
					{formatMessage({id: option?.label})}
				</SubNavigation.NavigationItem>
			))}
		</NavigatorWrapper>
	);
};

export default SettingsClientsSubNav;
